<template>
  <div class="login-container">
    <div class="content ">
      <div class="left">
        <div class="bg">
         <img src="@/assets/images/font.png" alt="" />
        </div>
      </div>
      <div class="right-container">
      <div class="right">
        <div class="title">欢迎登录</div>
        <el-form ref="form" :model="form">
          <el-form-item label="用户名">
            <el-input
              placeholder="用户名"
              v-model="form.username"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input
              placeholder="密码"
              v-model="form.password"
              show-password
            >
            </el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-col :span="15">
              <el-input placeholder="验证码" v-model="form.code"> </el-input>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="7">
              <img
                :src="data.code_img"
                @click="getCodeImg"
                style="height: 40px; width: 100%"
                alt=""
              />
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="12">
              <el-checkbox v-model="form.checked" style="color: #fff"
                >记住密码</el-checkbox
              >
            </el-col>
            <el-col :span="12" style="text-align: right">
              <span style="color: #fff">忘记密码？</span>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="login"
              class="btn"
              type="primary"
              style="width: 100%; line-height: 25px; font-size: 18px;"
              >登录</el-button
            >
          </el-form-item>
          <!-- <tree-form-item> -->
          <span style="color: #fff">✼建议使用Chrome浏览器访问本系统</span>
          <!-- </tree-form-item> -->
        </el-form>
      </div>
    </div>
    </div>
   <div class="bottom">
    <span class="company">嘉兴联控信息技术有限公司</span>
    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33040002330413" rel="noreferrer" style="color: #ffffff; display: flex;align-items: center;gap:0 10px;justify-content: center;" target="_blank">
      <img src="@/assets/images/icon.png"/>浙公网安备33040002330413号</a>
      <a href="https://beian.miit.gov.cn/">浙ICP备2023043656号-1</a>
   </div>
  </div>
</template>

<script>
import { setToken, setFlashToken, removeToken } from '@/utils/auth';
import { GetCodeImg, Login } from '@/api/login';
export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
        code: '',
        checked: false,
      },
      data: {
        code_img: '',
      },
    };
  },
  created() {
    // 正式显示页面内容
    // this.isReload = true
    removeToken();
    this.getCodeImg();
  },
  methods: {
    getCodeImg() {
      GetCodeImg().then((res) => {
        this.data.code_img = res.base64;
      });
    },
    login() {
      const params = {
        username: this.form.username,
        password: this.form.password,
        code: this.form.code,
        client: 'gateway',
      };
      Login(params)
        .then((res) => {
          setToken(res.access_token);
          setFlashToken(res.refresh_token);
          this.$store.commit('home/RoleId', res.RoleId);
          localStorage.RoleId = res.RoleId;
          localStorage.user = JSON.stringify(res);
          this.$router.push({ name: 'Home' });
          // eslint-disable-next-line no-console
          console.log(this.$store.state);
        })
        .catch((error) => {
          this.getCodeImg();
          //  this.$message.error(error.error_description)
        });
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  justify-content: space-between;
   
     background: rgba(53, 57, 64, 0.85);
     color: #fff;
  .content {
   width: 100%;
   height: 92%;
    display: flex;
  background-image: url('~@/assets/images/login-bg1.jpg');
  background-size: cover;
    background-position: center;
    align-items: center;
  }
  .left {
    float: left;
    width:70%;
    height: 90%;
 

   .bg{
      width: 80%;
      margin: 0 auto;
      margin-top: 10vh;
      img{
        width: 100%;
      }
   
   }
  }
  .right-container{
    width: 35%;
    height: 100%;
    display: flex;
    align-items: center;
    background: rgba(53, 57, 64, 0.85);
    justify-content: center;
  }
  .right {
    width:400px;
    padding: 50px 50px;
    // margin-right: 30px;
    .title {
      font-size: 32px;
      color: #fff;
      padding-bottom: 48px;
      text-align: center;
    }
  }
  .bottom {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .company{
      margin: 10px 0;
      font-size: 20px;
    }
    a{
      color: #fff;
    }
  }
}
.btn{
  margin-top: 48px;
}
/deep/ .el-form-item__label{
  color: #fff;
}
</style>
